import { render, staticRenderFns } from "./Speaking.vue?vue&type=template&id=fcbe8ee6&scoped=true&"
import script from "./Speaking.vue?vue&type=script&lang=js&"
export * from "./Speaking.vue?vue&type=script&lang=js&"
import style0 from "./Speaking.vue?vue&type=style&index=0&id=fcbe8ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbe8ee6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
